<template>
  <div :class="$style.ctn">
    <div ref="content" :class="$style.content" v-html="svg" />
    <div :class="$style.controls" @dblclick.stop @click.stop>
      <button type="button" @click="resize(-1)">
        -
      </button>
      <button type="button" @click="resize(1)">
        +
      </button>
    </div>
  </div>
</template>
<script>
import panzoom from 'panzoom';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    svg: { type: String, required: true },
  },
  data: () => ({
    viewer: null,
    beforeMove: null,
    timeout: null,
  }),
  mounted() {
    const { content } = this.$refs;

    this.$nextTick(() => {
      // timeout: chrome render bug fix
      this.timeout = setTimeout(() => {
        this.viewer = panzoom(content, {
          bounds: false,
          autocenter: true,
          minZoom: 0.1,
          maxZoom: 4,
        });
        this.timeout = null;
      }, 1000);
    });

    content.querySelectorAll('[id].node').forEach((element) => {
      element.addEventListener('click', this.graphClick);
      element.addEventListener('mousedown', this.graphMouseDown);
    });
  },
  beforeUnmount() {
    if (this.timeout === null) clearTimeout(this.timeout);
    content.querySelectorAll('[id].node').forEach((element) => {
      element.removeEventListener('click', this.graphClick);
      element.removeEventListener('mousedown', this.graphMouseDown);
    });
  },
  methods: {
    resize(modifer) {
      this.viewer.smoothZoom(500, 250, 1 + modifer * 0.5);
    },
    graphMouseDown(event) {
      this.beforeMove = { pageX: event.pageX, pageY: event.pageY };
    },
    graphClick(event) {
      let { id } = event.currentTarget;

      const deltaX = Math.abs(this.beforeMove.pageX - event.pageX);
      const deltaY = Math.abs(this.beforeMove.pageY - event.pageY);
      if (deltaX > 10 || deltaY > 10) return;

      if (id.includes('-mainprocess')) {
        id = id.substr(0, id.indexOf('-mainprocess'));
      }
      if (id.includes('|')) {
        id = id.substr(0, id.indexOf('|'));
      }
      if (id.includes('undefined')) {
        id = id.substr(0, id.indexOf('undefined'));
      }
      this.$emit('select', id);
    },
  },
});
</script>
<style lang="scss">
.node[id] {
  cursor: pointer;
  &:hover {
    opacity: 0.5;
  }
}
.node * {
  font-family: "Helvetica" !important;
}
</style>

<style lang="scss" module>
.ctn {
  border: 1px solid var(--table-border-color);
  position: relative;
  overflow: hidden;
}
.content {
  padding: 12px;
  position: absolute;
  transform-style: preserve-3d;

  &,
  svg {
    display: block;
  }

  @media print {
    transform: none !important;
    transform-origin: initial !important;
    &,
    svg {
      height: 100% !important;
      width: 100% !important;
    }
  }
}

.controls {
  z-index: 1;
  position: absolute;
  display: flex;
  padding: 12px;
  right: 0;
  top: 0;

  & > button {
    background: #eaeff3;
    color: #3f4757;
    font-weight: 500;
    font-size: 18px;
    display: block;
    text-align: center;
    line-height: 25px;
    width: 25px;

    & + * {
      margin-left: 6px;
    }

    &:hover {
      background-color: #e0eaf2;
    }
  }
  @media print {
    display: none;
  }
}
</style>
